import { motion } from 'framer-motion';
import { useVideoTransition } from '../hooks/useVideoTransition';
import { useOverlay } from '../App';
import { useEffect, useRef } from 'react';
import { useStars } from '../context/StarContext';
import StarPoint from './StarPoint';

const PassiveScreen = () => {
    const { handleNavigate, setIsPlaying } = useVideoTransition();
    const { toggleOverlay } = useOverlay();
    const { loading, publicStars, starPositions } = useStars();
    const isSeamlessTransition = useRef(
        typeof window !== 'undefined' && window.STILL_LOVED_SEAMLESS_TRANSITION
    );

    useEffect(() => {
        // Show the header when needed
        toggleOverlay(true);
        
        // Hide the header when component unmounts
        return () => toggleOverlay(false);
    }, [toggleOverlay]);
    
    // Handle video playback
    useEffect(() => {
        // If this is a seamless transition, the video is already playing
        if (isSeamlessTransition.current) {
            //console.log('Passive screen mounted');
            
            // Reset the flag
            if (typeof window !== 'undefined') {
                window.STILL_LOVED_SEAMLESS_TRANSITION = false;
            }
        } else {
            // For direct navigation, ensure the video plays
            // Only log in development
            if (process.env.NODE_ENV === 'development') {
                //console.log('Passive screen mounted with direct navigation');
            }
            
            // Add a small delay to ensure the video source is set
            setTimeout(() => {
                setIsPlaying(true);
            }, 100);
        }
    }, [setIsPlaying]);

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                duration: 1,
                staggerChildren: 0.5,
            },
        },
        exit: {
            opacity: 1,
            transition: {
                duration: 1
            }
        }
    };

    return (
        <motion.div 
            className="relative h-screen overflow-hidden"
            variants={containerVariants}
            initial="hidden"
            animate="visible"
        >
            {/* Empty container */}
        </motion.div>
    );
};

export default PassiveScreen; 